import { useCallback, useEffect, useRef, useState } from "react";

import { type Segment } from "./segment_copy";

// Matches the kit's home_behavior.js: the chips answer immediately, the copy
// underneath cross-fades 180ms later, and the panels get a one-shot wash so the
// change reads as the same case being re-examined rather than a page swap.
const FADE_MS = 180;

export const useHomeSegments = () => {
  const [segment, setSegment] = useState<Segment>("medical");
  const [copySegment, setCopySegment] = useState<Segment>("medical");
  const [fading, setFading] = useState(false);
  const [washing, setWashing] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout>>(undefined);

  const select = useCallback((next: Segment) => {
    setSegment(next);
    setFading(true);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      setCopySegment(next);
      setWashing(true);
    }, FADE_MS);
  }, []);

  useEffect(() => () => clearTimeout(timer.current), []);

  // Fade the new copy back in on the frame after it renders, so the paragraph
  // transitions from the opacity:0 it was mounted with rather than popping in.
  useEffect(() => {
    const frame = requestAnimationFrame(() => setFading(false));
    return () => cancelAnimationFrame(frame);
  }, [copySegment]);

  return {
    segment,
    copySegment,
    fading,
    washing,
    select,
    endWash: useCallback(() => setWashing(false), []),
  };
};
